// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2F4Rf","title":"FrontImage_title__2IMtt"};